import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ColDef, Module } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import * as agGrid from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { BillingComponent } from '../billing/billing.component';
import { routes } from '../../../../shared/routes/routes';
import { ApiService } from '../../../../api.service';
import { CommonService } from '../../../../shared/common/common.service';
import {
  PLANS,
  SUBSCRIPTION_PLANS,
} from '../../../../shared/constants/global-constant';

@Component({
  standalone: false,
  selector: 'app-p-subscription',
  templateUrl: './p-subscription.component.html',
  styleUrls: ['./p-subscription.component.scss'],
})
export class PSubscriptionComponent {
  @ViewChild(BillingComponent) BillingComponent!: BillingComponent;
  managePlanData: any = [];
  plans = PLANS;
  subscriptionPlans = SUBSCRIPTION_PLANS;
  currentRowSelectedIndex: any;
  bundle_id: any;
  usubscribeCate: boolean = false;
  languageMap: { [categoryId: number]: string } = {};
  selectRemovalAll: boolean = true;
  selectedRemovalCategories: Set<number> = new Set();
  showRemoval: boolean = true;
  showUnsubCat: boolean = false;
  usubscribeUser: boolean = false;
  selectedCategories: { [key: number]: string } = {};
  showAdditional: boolean = false;
  billing_id: any;
  gridReady = false;
  public searchDataValue = '';
  @ViewChild('agGrid') agGrid: AgGridAngular | any;
  public tooltipShowDelay = 0;
  public tooltipHideDelay = 2000;
  @ViewChild('filtertextbox') filtertext!: ElementRef;
  SerachedRow: number | undefined;
  selectedTabIndex = 0;
  private gridApi: any;
  private gridColumnApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  visiblePageCount = 5;
  startPage = 1;
  fromRecord = 0;
  toRecord = 0;
  totalRecords = 0;
  totalPage: number = 0;
  currPage: number = 0;
  paging: number[] = [];
  NoRecordsFound!: boolean;
  activeTab: string = 'manage';
  public routes = routes;
  dependentData: any = [];
  billingHistoryDetails: any = {};
  userProfile: any = {};
  userSubscription: any = {};
  featureNames: any = [];
  bundlePacksDetails: any;
  showPopup = false;
  selectedLanguage = 1;
  selectAll = false;
  selectAllRemoval = true;
  selectedTab: string = '';
  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    lockPosition: true,
  };
  rowData: any = [];
  isEditMode = false;
  managePopup = false;
  currentEcoCashNumber: string = '';
  editedEcoCashNumber: string = '';
  originalEcoCashNumber: string = '';
  isSaveDisabled: boolean = true;
  contactNumberError: boolean = false;
  showOtp: boolean = false;
  maxLength = 9;

  colDefs: ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => {
        const rowNode = params.node;
        const model = params.api.getModel();
        const allRows: any[] = [];
        model.forEachNodeAfterFilterAndSort((node: any) => {
          allRows.push(node);
        });
        const globalIndex = allRows.findIndex((node) => node === rowNode);
        return globalIndex + 1;
      },
      flex: 0.5,
      minWidth: 70,
      editable: false,
      resizable: false,
      filter: false,
      sortable: false,
      lockPosition: true,
    },
    {
      headerName: 'Plan Name',
      cellRenderer: (params: any) => {
        const value =
          (params.data?.subBundle?.bundle_name || '') +
          ' ' +
          (params.data?.subPack?.pack_name || '');
        const text = value.trim() || 'N/A';
        const span = document.createElement('span');
        span.innerText = text;
        span.title = text;
        return span;
      },
      flex: 1,
      minWidth: 140,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Billing Type',
      cellRenderer: (params: any) => {
        const addon = params.data.is_addon;
        let value = 'N/A';
        if (addon === 0) value = 'Main Plan';
        else if (addon === 1) value = 'Additional Category';

        const span = document.createElement('span');
        span.innerText = value;
        span.title = value;
        return span;
      },
      flex: 1,
      minWidth: 130,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Category',
      cellRenderer: (params: any) => {
        const value = params.data?.category?.category_name || 'N/A';
        const text = value.trim();

        const span = document.createElement('span');
        span.innerText = text;
        span.title = text;
        return span;
      },
      flex: 1.5,
      minWidth: 150,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Start Date',
      flex: 1,
      minWidth: 120,
      valueGetter: (params: any) => {
        const rawDate = params.data?.first_billing_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'First Billing Date',
      flex: 1,
      minWidth: 140,
      valueGetter: (params: any) => {
        const rawDate = params.data?.first_billing_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Renew Date',
      flex: 1,
      minWidth: 120,
      valueGetter: (params: any) => {
        const rawDate = params.data?.renewal_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Status',
      valueGetter: (params: any) => {
        const id = params.data.subStatus?.sub_status_id;
        if ([1, 15].includes(id)) return 'Active';
        if ([9, 4].includes(id)) return 'Low Balance';
        if ([0, 2, 14, 8, 19, 25].includes(id)) return 'In Progress';
        if ([20].includes(id)) return 'Deactivated';
        return 'Unknown';
      },
      flex: 1,
      minWidth: 100,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Action',
      flex: 1,
      minWidth: 130,
      cellRenderer: (params: any) => {
        const is_addon = params.data?.is_addon;
        const sub_status = params.data?.subStatus?.sub_status;
        const showUnsubscribe = is_addon === 0 && sub_status === 'Active';

        return `
        <div style="display: flex; justify-content: center; align-items: center; gap: 10px;height: -webkit-fill-available;">
          <img style="width: 20px; cursor: pointer;" 
               src="assets/img/visual.png" class="visual-icon" title="View" />
          <img style="width: 20px; cursor: pointer;" 
               src="assets/img/unsubscribe.webp" class="remove-icon" title="Unsubscribe" />
          ${
            showUnsubscribe
              ? `<img style="width: 20px; cursor: pointer;" 
                       src="assets/img/plus.png" class="add-icon" title="Add category" />`
              : `<span style="width: 20px;"></span>`
          }
        </div>
      `;
      },
      onCellClicked: (params: any) => {
        const target = params.event?.target as HTMLElement;
        if (!target) return;
        const rowIndex = params.node?.rowIndex;
        if (target.classList.contains('visual-icon')) {
          this.currentRowSelectedIndex = rowIndex;
          localStorage.setItem('currentRowIndex', rowIndex);
          this.openVisualPopup(params.data, rowIndex + 1);
        } else if (target.classList.contains('add-icon')) {
          this.currentRowSelectedIndex = rowIndex;
          localStorage.setItem('currentRowIndex', rowIndex);
          this.openPopup(params.data);
        } else if (target.classList.contains('remove-icon')) {
          this.currentRowSelectedIndex = rowIndex;
          localStorage.setItem('currentRowIndex', rowIndex);
          this.openPopupForRemove(params.data);
        }
      },
      lockPosition: true,
      sortable: false,
      resizable: true,
    },
  ];

  languages = ['English', 'Shona', 'Ndebele'];
  healthTips: any[] = [];
  subDetail: any;
  popupData: any;
  popupVisible: boolean = false;
  objectKeys = Object.keys;
  unsubscribeData: any;
  allPacks: any;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private router: Router,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
  ) {}

  openVisualPopup(data: any, serialNo: any) {
    this.popupData = data;
    this.popupData.serialNo = serialNo;
    this.popupVisible = true;
  }

  closeVisualPopup() {
    this.popupVisible = false;
    this.popupData = null;
  }

  getFormattedDobWithAge(dob: string): string {
    if (!dob || dob === '0000' || dob.trim() === '') {
      return '';
    }

    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const birthDate = new Date(dob);

    if (isNaN(birthDate.getTime()) || birthDate.getFullYear() === 1970) {
      return '';
    }

    const today = new Date();
    const day = birthDate.getDate();
    const month = months[birthDate.getMonth()];
    const year = birthDate.getFullYear();

    let age = today.getFullYear() - year;
    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= day);

    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return `${day} ${month} ${year}, ${age} years`;
  }
  checkEnabledDisbaled() {
    return (
      JSON.parse(localStorage.getItem('user') || '{}').role === 'Dependent'
    );
  }

  moveToSelectCards(length: any) {
    if (length > 0) {
      localStorage.setItem('explore', 'explore');
    } else {
      localStorage.removeItem('explore');
    }
    localStorage.removeItem('category');
    this.router.navigate(['/patients/patient-dashboard/subscription']);
  }

  getUniquePlans(): any[] {
    const seen = new Set<string>();
    return (this.managePlanData || []).filter((plan: any) => {
      const name = plan?.subBundle?.bundle_name;
      const isActive = plan?.subStatus?.sub_status === 'Active';

      if (name && isActive && !seen.has(name)) {
        seen.add(name);
        return true;
      }

      return false;
    });
  }

  getUserSubscription() {
    this.spinner.show();
    this.apiService.getUserSubscription().subscribe(
      (res: any) => {
        if (res.subscriptionData) {
          localStorage.setItem(
            'subDetail',
            JSON.stringify(res.subscriptionData),
          );
        }
        this.userSubscription = [];
        this.dependentData = [];
        this.featureNames = [];
        this.userSubscription = res || {};
        if (
          this.userSubscription?.managePlanData &&
          Array.isArray(this.userSubscription.managePlanData)
        ) {
          this.rowData = this.userSubscription?.managePlanData;
        } else {
          this.rowData = [];
        }
        if (
          this.userSubscription?.dependentData &&
          Array.isArray(this.userSubscription?.dependentData)
        ) {
          this.userSubscription?.dependentData.forEach((item: any) => {
            const fullName =
              item?.dependentUser?.full_name?.trim() ||
              `${item?.dependentUser?.first_name || ''} ${
                item?.dependentUser?.last_name || ''
              }`.trim();

            this.dependentData.push({
              name: fullName,
              id: item?.dependentUser?.user_id,
            });
          });
        }
        this.userSubscription.userData.full_name =
          this.userSubscription.userData.full_name ||
          `${this.userSubscription.userData.first_name || ''} ${
            this.userSubscription.userData.last_name || ''
          }`.trim();

        this.spinner.hide();

        this.managePlanData = (this.userSubscription.managePlanData || []).map(
          (bundle: any, index: number) => {
            const match = this.plans.find(
              (plan) =>
                plan.name.toLowerCase() ===
                bundle.subBundle.bundle_name.toLowerCase(),
            );

            return {
              ...bundle,
              icon: match?.icon || '',
              tagline: match?.tagline || '',
              description: match?.description || '',
              features: bundle.featurePlanData || [],
            };
          },
        );

        const uniquePlans = this.getUniquePlans();
        localStorage.setItem('planDetail', JSON.stringify(uniquePlans));
      },
      (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    );
  }
  getBundlePacks() {
    this.spinner.show();
    this.apiService.getUserBundlePacks().subscribe(
      (res: any) => {
        this.bundlePacksDetails = res || {};
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    );
  }
  openPopupForRemove(bundle_id: any) {
    this.unsubscribeData = bundle_id;
    this.usubscribeCate = true;
  }
  openPopup(data: any) {
    this.showAdditional = false;
    this.router.navigate(['patients/patient-dashboard/subscription']);
    this.commonService.sendCategroData(true);
    this.userSubscription.addedData = data;
    localStorage.setItem('category', JSON.stringify(this.userSubscription));

    const selectedPlan = this.allPacks.find(
      (el: any) => el?.bundle_id == data?.subBundle?.bundle_id,
    );
    localStorage.setItem(
      'homeSelectionPlan',
      JSON.stringify({ allPlans: this.allPacks, plan: selectedPlan }),
    );
  }

  onLanguageChange() {
    this.healthTips.forEach((tip) => (tip.is_selected = false));
  }

  closePopup() {
    this.spinner.hide();
    this.showPopup = false;
  }

  toggleAdditional() {
    this.showAdditional = !this.showAdditional;
  }

  toggleRemoval() {
    this.showRemoval = !this.showRemoval;
  }

  isCategorySelected(id: number): boolean {
    return this.selectedCategories.hasOwnProperty(id);
  }

  toggleCategory(id: number, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedCategories[id] = '';
    } else {
      delete this.selectedCategories[id];
    }
  }

  updateLanguage(id: number, lang: string) {
    if (this.isCategorySelected(id)) {
      this.selectedCategories[id] = lang;
    }
  }

  getCategoryLanguage(id: number): string {
    return this.selectedCategories[id] || '';
  }

  isAllSelected(): boolean {
    return this.healthTips.every((cat) =>
      this.isCategorySelected(cat.category_id),
    );
  }

  toggleSelectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.healthTips.forEach(
        (cat) => (this.selectedCategories[cat.category_id] = ''),
      );
    } else {
      this.selectedCategories = {};
    }
  }

  saveChanges() {
    if (
      !this.selectedCategories ||
      !Object.keys(this.selectedCategories).length
    ) {
      this.toastrService.warning('Select atleast one category', '', {
        timeOut: 1000,
      });
      return;
    }
    const languageMap: any = { English: 1, Shona: 2, Ndebele: 3 };
    const categoryEntries = Object.entries(this.selectedCategories);

    for (let i = 0; i < categoryEntries.length; i++) {
      const [id, lang] = categoryEntries[i];
      if (!lang || !lang.trim()) {
        this.toastrService.warning('Please select language', '', {
          timeOut: 1000,
        });
        return;
      }
    }

    const selectedWithLanguages = categoryEntries.map(([id, lang]) => ({
      category_id: +id,
      language_id: languageMap[lang] || null,
    }));

    this.apiService
      .SaveUserCategory({
        user_id: this.userProfile.user_id,
        categories: selectedWithLanguages,
      })
      .subscribe((res) => {
        if (res.success) {
          this.healthTips = [];
          this.selectedCategories = [];
          this.showPopup = false;
          this.toastrService.success('Subscribed successfuly', '', {
            timeOut: 1000,
          });
        }
      });
    return;
  }

  selectTab(index: number, id: any) {
    this.selectedTabIndex = index;
    this.billing_id = id;
    if (index == 0) {
      this.getUserSubscription();
    } else {
      this.getDependentSubscription(id);
    }
  }
  getDependentSubscription(id: any) {
    this.spinner.show();
    this.apiService.getDependentSubscription(id).subscribe(
      (res: any) => {
        this.userSubscription = [];
        this.userSubscription = res || {};
        if (
          this.userSubscription.managePlanData &&
          Array.isArray(this.userSubscription.managePlanData)
        ) {
          this.userSubscription.managePlanData.forEach((item: any) => {
            this.featureNames.push(item.feature_name);
          });
        }
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    );
  }

  reload(data: any) {
    this.showOtp = false;
    if (this.activeTab === 'manage') {
      this.getUserSubscription();
    } else {
      this.BillingComponent.getUserBillingHository(this.userProfile.user_id);
    }
  }

  ngOnInit() {
    localStorage.removeItem('explore');

    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');

    this.getBundlePacks();
    this.getUserSubscription();
    this.loadBundlePacks();

    this.currentEcoCashNumber = this.userProfile.billing_number
      ? this.userProfile.billing_number
      : this.userProfile.phone;

    this.subDetail = JSON.parse(localStorage.getItem('subDetail') || '{}');
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  ngOnDestroy() {
    this.gridApi = null;
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    if (this.activeTab === 'manage') {
      this.getUserSubscription();
    }
  }

  isActiveTab(tab: string): boolean {
    return this.activeTab === tab;
  }

  unsubscribeCurrentUser() {
    this.usubscribeUser = !this.usubscribeUser;
  }

  confirmCancel() {
    this.spinner.show();
    this.apiService
      .UserUnsub({ phone: this.userProfile.phone, channelId: 1 })
      .subscribe(
        (ele: any) => {
          if (ele.success) {
            this.toastrService.success('User unsubscribed successfully', '', {
              timeOut: 1000,
            });
          } else {
            this.toastrService.error(
              'An error occurred during unsubscription',
              '',
              { timeOut: 1000 },
            );
          }
          this.spinner.hide();
        },
        (error) => {
          this.toastrService.error(
            'An error occurred: ' + (error.message || 'Unknown error'),
          );
          this.spinner.hide();
        },
      );
  }

  toggleRemovalSelectAll(event: any) {
    this.selectAllRemoval = event.target.checked;
    if (this.selectAllRemoval) {
      this.healthTips.forEach((cat) =>
        this.selectedRemovalCategories.add(cat.category_id),
      );
    } else {
      this.selectedRemovalCategories.clear();
    }
  }

  isCategoryRemovalSelected(catId: number): boolean {
    return this.selectedRemovalCategories.has(catId);
  }

  toggleSingleCheckbox(catId: number, event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      this.selectedRemovalCategories.add(catId);
      if (this.selectedRemovalCategories.size === this.healthTips.length) {
        this.selectAllRemoval = true;
      }
    } else {
      if (this.selectedRemovalCategories.size === 1) {
        this.selectedRemovalCategories.clear();
        this.selectAllRemoval = false;
      } else {
        this.selectedRemovalCategories.delete(catId);
      }
    }
  }

  UnSubCategory() {
    this.spinner.show();
    const payload = {
      phone: this.userSubscription.userData.phone,
      channelId: 1,
      bundleId: this.unsubscribeData.subBundle.bundle_id,
      categoryIds: [this.unsubscribeData.category.category_id],
    };
    this.apiService.USubCate(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          switch (res.message) {
            case 'deactivateAll':
              this.toastrService.success(
                'All categories have been deactivated successfully',
                '',
                { timeOut: 1000 },
              );
              break;
            case 'deactivated':
              this.toastrService.success('Deactivated successfully', '', {
                timeOut: 1000,
              });
              break;
            case 'alreadyDeactivated':
              this.toastrService.info(
                'This category is already deactivated',
                '',
                { timeOut: 1000 },
              );
              break;
            default:
              this.toastrService.success(res.message);
              break;
          }
        } else {
          switch (res.message) {
            case 'categoryNotPresent':
              this.toastrService.error(
                'The category you are trying to deactivate does not exist',
                '',
                { timeOut: 1000 },
              );
              break;
            default:
              this.toastrService.error(res.message);
              break;
          }
        }
        setTimeout(() => {
          this.usubscribeCate = false;
          localStorage.removeItem('subDetail');
          localStorage.removeItem('planDetail');
          this.getUserSubscription();
          this.spinner.hide();
        }, 4000);
      },
      error: (err) => {
        this.spinner.hide();
        this.usubscribeCate = false;
        this.toastrService.error(
          err.error.message ||
            err.message ||
            'An error occurred while unsubscribing categories',
        );
      },
    });
  }

  openConfirm() {
    if (this.selectedRemovalCategories.size === 0) {
      this.toastrService.warning(
        'Please select at least one category to unsubscribe.',
        '',
        { timeOut: 1000 },
      );
      this.spinner.hide();
      return;
    }
    this.usubscribeCate = true;
  }

  loadBundlePacks(): void {
    this.apiService.getUserBundlePacks(true).subscribe(
      (res: any) => {
        const formattedData = this.formatBundleData(res?.bundleData || []);
        this.allPacks = formattedData;
      },
      (err: any) => {
        console.log(err, 'errir');
      },
    );
  }

  private formatBundleData(bundles: any[]): any[] {
    return bundles.map((bundle: any) => {
      const match = this.plans.find(
        (plan) => plan.name.toLowerCase() === bundle.bundle_name.toLowerCase(),
      );
      return {
        ...bundle,
        icon: match?.icon || '',
        tagline: match?.tagline || '',
        description: match?.description || '',
        subIcons: match?.subIcons || [],
      };
    });
  }

  enableEdit() {
    this.isEditMode = true;
    this.editedEcoCashNumber = this.currentEcoCashNumber;
    this.originalEcoCashNumber = this.currentEcoCashNumber;

    this.checkSaveButtonState();
    this.cdr.detectChanges();
  }

  saveNumber() {
    if (this.isSaveDisabled) return;

    this.currentEcoCashNumber = this.editedEcoCashNumber;

    const payload = {
      phone_number: this.editedEcoCashNumber,
      user_id: this.userProfile.user_id,
      otp_type: 'MANAGE ECOCASH',
    };

    this.apiService.sendEcocashOtp(payload).subscribe(
      ({ success }) => {
        if (success) {
          this.toastrService.success('OTP sent successfully', '', {
            timeOut: 4000,
          });

          this.isEditMode = false;
          this.managePopup = false;
          this.showOtp = true;
          this.cdr.detectChanges();

          localStorage.setItem(
            'auth',
            JSON.stringify({ phone: this.editedEcoCashNumber }),
          );
        } else {
          this.toastrService.error(
            'OTP sending failed. Please try again.',
            '',
            { timeOut: 4000 },
          );
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        }

        this.spinner.hide();
      },
      (error) => {
        console.error('API Error:', error.error);
        setTimeout(() => {
          this.spinner.hide();
        }, 2000);

        const errorMessage =
          error?.error?.error ||
          error?.message ||
          error?.error?.message ||
          'Something went wrong.';

        this.toastrService.error(errorMessage, '', { timeOut: 4000 });
      },
    );
  }

  cancelEdit() {
    this.isEditMode = false;
    this.managePopup = false;
    this.reload('');
    this.cdr.detectChanges();
  }

  closeManagePopup() {
    this.managePopup = false;
    this.cdr.detectChanges();
  }

  manageEcocash() {
    const userId = this.userProfile.user_id;

    this.apiService.getUserProfileRecord(userId).subscribe(
      (res: any) => {
        this.userProfile = res.data || {};
        localStorage.setItem('user', JSON.stringify(this.userProfile));
        this.currentEcoCashNumber = this.userProfile.billing_number
          ? this.userProfile.billing_number
          : this.userProfile.phone;
        this.cdr.detectChanges();
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    );

    this.managePopup = true;
    this.isEditMode = false;
    this.cdr.detectChanges();
  }

  validateLoginNumber(ev: any) {
    const rawValue = ev?.target?.value || '';
    const onlyDigits = rawValue.replace(/\D/g, '');
    ev.target.value = onlyDigits;
    this.editedEcoCashNumber = onlyDigits;
    this.maxLength = onlyDigits.startsWith('0') ? 10 : 9;
    const expectedLength = this.maxLength;
    this.contactNumberError = !(onlyDigits.length === expectedLength);

    this.checkSaveButtonState();
  }

  checkSaveButtonState() {
    const noChange = this.editedEcoCashNumber === this.originalEcoCashNumber;
    this.isSaveDisabled =
      noChange ||
      this.contactNumberError ||
      this.editedEcoCashNumber.trim() === '';
  }

  blockNonNumeric(event: any) {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete',
    ];

    if (allowedKeys.includes(event.key)) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    const inputValue = (event.target as HTMLInputElement).value;
    const digits = inputValue.replace(/\D/g, '');

    const cursorPos = (event.target as HTMLInputElement).selectionStart || 0;
    const expectedLength = digits.startsWith('0') ? 10 : 9;

    if (digits.length >= expectedLength && cursorPos === digits.length) {
      event.preventDefault();
    }
  }
}
